import { Logo, UserImage } from 'assets'
import React, { useEffect, useState } from 'react'
import './profile.css'
import axiosInstance from 'utils/axiosConfig'
import { createImageUrl } from 'utils/createImageUrl'
import { Loader } from 'components'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import {
   deleteChannelAction,
   getAllChannelListAction,
   resetDeleteChannelFlag,
   setChannelListArray,
   setSelectChannelId
} from 'store/action/settingsReducer'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { setAllVideoDataAction, setPageNumberAction } from 'store/action/videoReducer'

function Profile() {
   const [userInfo, setUserInfo] = useState(null)
   const [ownerChannels, setOwnerChannels] = useState(null)
   const [externalChannels, setExternalChannels] = useState(null)
   const [isLoading, setIsLoading] = useState(false)
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID, deleteChannelFlag, selectedUserTypes, channelList } = settingData
   const dispatch = useDispatch()
   const location = useLocation()
   const getParams = new URLSearchParams(location.search)
   const [channelType, setChannelType] = useState(null)
   const [deleteChannelId, setDeleteChannelId] = useState(null)

   const getMyProfileInfo = async () => {
      setIsLoading(true)
      try {
         let res = await axiosInstance.get('/user/profile/')
         if (res?.data?.data) {
            if (res?.data?.data?.user_info) {
               setUserInfo(res?.data?.data?.user_info)
            } else {
               setUserInfo(null)
            }
            if (res?.data?.data?.owner_channels && res?.data?.data?.owner_channels?.length > 0) {
               setOwnerChannels(res?.data?.data?.owner_channels)
            } else {
               setOwnerChannels(null)
            }
            if (
               res?.data?.data?.influencer_channels &&
               res?.data?.data?.influencer_channels?.length > 0
            ) {
               setExternalChannels(res?.data?.data?.influencer_channels)
            } else {
               setExternalChannels(null)
            }
            setIsLoading(false)
         }
      } catch (err) {
         setIsLoading(false)
         console.log(err)
      }
   }
   useEffect(() => {
      getMyProfileInfo()
      return () => {}
   }, [])

   function removeChannelById(channelId) {
      return channelList.filter((channel) => channel.channel_id !== channelId)
   }
   const removeChannel = (channel_id) => {
      // Try removing from both sets of channels
      setOwnerChannels((prev) =>
         prev ? prev.filter((channel) => channel.channel_id !== channel_id) : null
      )
      setExternalChannels((prev) =>
         prev ? prev.filter((channel) => channel.channel_id !== channel_id) : null
      )
   }

   useEffect(() => {
      if (deleteChannelFlag) {
         removeChannel(deleteChannelId)
         if (getParams.get('userType') === channelType) {
            let updatedChannelList = removeChannelById(deleteChannelId)
            if (deleteChannelId == getParams.get('channel_id')) {
               dispatch(setSelectChannelId(updatedChannelList[0]?.channel_id || null))
            }
            dispatch(setChannelListArray(updatedChannelList))
         }
         setChannelType(null)
         setDeleteChannelId(null)
         dispatch(setAllVideoDataAction([]))
         dispatch(setPageNumberAction(1))
         dispatch(resetDeleteChannelFlag())
      }
      return () => {}
   }, [deleteChannelFlag])

   const onDeleteChannel = (channel_id, type, channel_name) => {
      setChannelType(type)
      setDeleteChannelId(channel_id)
      Swal.fire({
         title: 'Are you sure?',
         text: `You won't delete this channel ${channel_name}!`,
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!',
         theme: 'dark'
      }).then((result) => {
         if (result.isConfirmed) {
            dispatch(deleteChannelAction({ channel_id: channel_id }))
         }
      })
   }

   return (
      <div className="profile-page">
         {isLoading && <Loader />}
         <div className="">
            <div className="profile-image-name-card">
               {userInfo && (
                  <div className="profile-detail-wrap">
                     <div className="card">
                        <div className="profile-photo">
                           <img src={createImageUrl(userInfo?.profile)} />
                        </div>
                        <div className="user-profile-info">
                           <div className="user-name at-text-bold">{`${userInfo?.first_name} ${userInfo?.last_name}`}</div>
                           <div className="user-email mt-1">{userInfo?.username}</div>
                           <div className="user-email mt-1">{userInfo?.email}</div>
                        </div>
                     </div>
                  </div>
               )}
            </div>
            {/* <div className="col-8"></div> */}
         </div>

         {ownerChannels ? (
            <div className=" owner-channel-section">
               <div className="card mt-3 ">
                  <h5>Owner Channel Information</h5>
                  <div className="channel-wrap">
                     {ownerChannels &&
                        ownerChannels?.length > 0 &&
                        ownerChannels?.map((item, i) => {
                           return (
                              <div className="card comment-card mt-3" key={i}>
                                 <div className="channel-info-wrap position-relative">
                                    <div
                                       className="channel-btn delete-btn"
                                       onClick={() => {
                                          onDeleteChannel(
                                             item?.channel_id,
                                             item?.is_from,
                                             item?.channel_name
                                          )
                                       }}>
                                       <span>Delete</span>
                                    </div>
                                    <div className="mt-1">
                                       <label className="me-2">Channel Name: </label>
                                       <span className="at-text-light">{item?.channel_name}</span>
                                    </div>
                                    <ShowMoreLessContent description={item?.description} />
                                    <div className="mt-1">
                                       <label className="me-2">Channel Creation Date: </label>
                                       <span className="at-text-light">
                                          {item?.creation_date
                                             ? dayjs(item?.creation_date).format('MMM DD YYYY')
                                             : '-'}
                                       </span>
                                    </div>
                                    <div className="mt-1">
                                       <label className="me-2">Channel Country: </label>
                                       <span className="at-text-light">{item?.country}</span>
                                    </div>
                                 </div>
                              </div>
                           )
                        })}
                  </div>
               </div>
            </div>
         ) : null}

         {externalChannels ? (
            <div className="external-channel-section">
               <div className="card mt-3 ">
                  <h5>External Channel Information</h5>
                  <div className="channel-wrap">
                     {externalChannels &&
                        externalChannels?.length > 0 &&
                        externalChannels?.map((item, i) => {
                           return (
                              <div className="card comment-card mt-3" key={i}>
                                 <div className="channel-info-wrap">
                                    <div
                                       className="channel-btn delete-btn"
                                       onClick={() => {
                                          onDeleteChannel(
                                             item?.channel_id,
                                             item?.is_from,
                                             item?.channel_name
                                          )
                                       }}>
                                       <span>Delete</span>
                                    </div>
                                    <div className="mt-1">
                                       <label className="me-2">Channel Name: </label>
                                       <span className="at-text-light">{item?.channel_name}</span>
                                    </div>
                                    <ShowMoreLessContent description={item?.description} />
                                    <div className="mt-1">
                                       <label className="me-2">Channel Creation Date: </label>
                                       <span className="at-text-light">
                                          {item?.creation_date
                                             ? dayjs(item?.creation_date).format('MMM DD YYYY')
                                             : '-'}
                                       </span>
                                    </div>
                                    <div className="mt-1">
                                       <label className="me-2">Channel Country: </label>
                                       <span className="at-text-light">{item?.country}</span>
                                    </div>
                                 </div>
                              </div>
                           )
                        })}
                  </div>
               </div>
            </div>
         ) : null}
      </div>
   )
}

export default Profile

const ShowMoreLessContent = ({ description }) => {
   const [showMore, setShowMore] = useState(false)
   const maxChars = 200

   const toggleText = () => setShowMore(!showMore)

   const shouldTruncate = description.length > maxChars
   const displayedText =
      showMore || !shouldTruncate ? description : `${description.slice(0, maxChars)}...`

   return (
      <div className="mt-1">
         <label className="me-2">Channel Description: </label>
         <span className="at-text-light">{displayedText}</span>
         {shouldTruncate && (
            <span onClick={toggleText} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
               {showMore ? 'Show Less' : 'Show More'}
            </span>
         )}
      </div>
   )
}
